import { render, staticRenderFns } from "./ConstructorPage.vue?vue&type=template&id=77cd1f08"
import script from "./ConstructorPage.vue?vue&type=script&lang=js"
export * from "./ConstructorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports